import * as React from "react";
import { useEffect, useState } from "react";

import "./button-view-cart.less";
import { ModalComponent } from "shared/components/modal/modal";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "app.hook";
import { shallowEqual, useSelector } from "react-redux";
import { ItemModalViewCart } from "./components/item-view-cart";
import { selectShoppingCart } from "states/shopping-cart/shopping-cart.slice";
import { nanoid } from "@reduxjs/toolkit";
import { CHECKOUT_ROUTE, VIEW_MENU_ROUTE } from "shared/constants/routes";
import { IconBasket } from "themes";
import { selectSignIn, showOrderGuestModal } from "states/global-value/global-value.slice";

export function ButtonModalViewCart() {
  const currentShoppingCart = useAppSelector(selectShoppingCart, shallowEqual);
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        className="btn--default button-view-cart-desktop rounded  px-3 py-3  lg:visible md:hidden  sm:hidden xs:hidden space-y-1 btn--primary fixed bottom-10 right-1"
      >
        <span className="block flex">
          <IconBasket width={20} /> Cart (
          {currentShoppingCart.items ?
            currentShoppingCart.items.map(m => m.quantity).reduce((a, b) => a + b, 0)
            : 0})
        </span>
      </button>
      <ModalComponent
        portalClassName={`ViewCartDesktop`}
        isCustomizeFooter={true}
        isModal={true}
        className=""
        title={"View Cart"}
        isOpenModal={modalIsOpen}
        onCloseModal={handleCloseModal}
      >
        <div className="py-4">
          <table className="w-full mt-5 border-collapse">
            <thead>
              <tr className="bg-gray-900 text-base text-white ">
                <th className="uppercase font-normal text-center py-2">
                  Image
                </th>
                <th className="uppercase font-normal py-2">Item</th>
                <th className="uppercase font-normal text-center py-2">Qty</th>
                <th className="uppercase font-normal text-center py-2">
                  Sub total
                </th>
                <th className="uppercase font-normal text-center py-2">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {currentShoppingCart?.items?.map((item, index) => (
                <ItemModalViewCart index={index} key={nanoid()} item={item} />
              ))}
            </tbody>
          </table>
          <div className="space-x-2 text-center pt-5 mx-auto py-2 border-t  border-gray-300 footer-cart">
            {location.pathname === VIEW_MENU_ROUTE ? (
              <button
                onClick={handleCloseModal}
                className="btn--default px-8 transition-primary  uppercase btn--secondary hover:btn--secondary"
              >
                add more item
              </button>
            ) : (
              <Link
                to={VIEW_MENU_ROUTE}
                className="btn--default px-8 transition-primary  uppercase btn--secondary hover:btn--secondary"
              >
                add more item
              </Link>
            )}
            {location.pathname === CHECKOUT_ROUTE ? (
              <button
                onClick={handleCloseModal}
                className="btn--default px-8 transition-primary uppercase btn--primary"
              >
                proceed to payment
              </button>
            ) : (
              <button
                onClick={() => {
                  if (!isLogged) {
                    dispatch(showOrderGuestModal());
                  } else {
                    history.push(CHECKOUT_ROUTE);
                  }
                  handleCloseModal();
                }}
                className="btn--default px-8 transition-primary uppercase btn--primary"
                aria-label=" proceed to payment"
              >
                proceed to payment
              </button>
            )}
          </div>
        </div>
      </ModalComponent>
    </>
  );
}
